<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <boton-atras :nombre_ruta="'MenuArmonizacion'"/>
        </div>
        <div class="container text-center mb-4">
            <h1 class="bold300 text-uppercase" style=" font-weight:500;">{{ data.titulo }} </h1>
        </div>
        <div v-if="data" class="col-md-12">
          <table class="styled-table">
            <tbody>
              <tr>
                <td>
                  <ul>
                    <li  v-for="(contenido, index) in data.contenido" :key="index">
                      <div class="contenido-fila">
                        <!-- Mostrar título -->
                        <span class="contenido-titulo strong">
                          {{ contenido.titulo }} <small class="text-muted">{{ contenido.pieTitulo }}</small>
                        </span>
                          <!-- Contenedor para los íconos -->
                          <div class="iconos-contenedor">
                            <a v-if="contenido.url_word" :href="urlServe + contenido.url_word" target="_blank">
                              <i class="fas fa-file-word icono-archivo icon-word"></i>
                            </a>
                            <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank">
                              <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                            </a>
                            <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank">
                              <i class="fas fa-file-excel icono-archivo icon-excel"></i>
                            </a>
                            <a v-if="contenido.url_comprimido" :href="urlServe + contenido.url_comprimido" target="_blank">
                              <i class="fas fa-file-archive icono-archivo icon-rar"></i>
                            </a>
                          </div>
                      </div>
                      <div v-if="contenido.contenido.length>0">
                        <div v-for="(contenido, index) in contenido.contenido" :key="index">
                          <!-- <pre>{{ contenido.titulo }}</pre> -->
                          <div class="contenido-fila">
                            <!-- Mostrar título -->
                            <span class="contenido-titulo my-2 ml-4 border-bottom">{{ contenido.titulo || 'Descargar documento' }} <small class="text-muted">{{ contenido.pieTitulo }}</small> </span>

                            <!-- Contenedor para los íconos -->
                            <div class="iconos-contenedor">
                              <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank">
                                <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                              </a>
                              <a v-if="contenido.url_word" :href="urlServe + contenido.url_word" target="_blank">
                                <i class="fas fa-file-word icono-archivo icon-word"></i>
                              </a>
                              <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank">
                                <i class="fas fa-file-excel icono-archivo icon-excel"></i>
                              </a>
                              <a v-if="contenido.url_comprimido" :href="urlServe + contenido.url_comprimido" target="_blank">
                                <i class="fas fa-file-archive icono-archivo icon-rar"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <span v-html="fecha_actualizacion"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import ArmonizacionContable from "@/services/ArmonizacionContable/ArmonizacionContable.service.js";
const _serviciosArmonizacionContable = new ArmonizacionContable();
import botonAtras from './../button-atras'
import DateFormat from "@/mixins/dateFormatMixin.js";
import tablaSimple from '@/components/tablaSimple.vue';

export default {
    name: 'AvanceChiapas',
    mixins: [DateFormat],
    components: { botonAtras,tablaSimple },
    data() {
        return {
          data: [],
          fecha_actualizacion: ''
        };
    },
    async created() {
        await this.getMenuFinanzasPublicas();
    },
    methods: {
        async getMenuFinanzasPublicas() {
            try {
                const response = await _serviciosArmonizacionContable.getAvanceChiapas(mapFun.avanceChiapas);
                this.data = response.data[0];
                // console.log(this.data.fecha_actualizacion);
                this.fecha_actualizacion = this.DateFormatText(this.data.fecha_actualizacion);

            } catch (error) {
                console.log('error', error.message);
            }
        }
    }
}
</script>
<style scoped>
.strong{ font-weight: 600;}
</style>
